document.addEventListener('DOMContentLoaded', function () {
  var observedRoots = new WeakSet();
  var scheduled = false;

  function enableSoldOutOptions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var inputs = scope.querySelectorAll('.option-value-input');

    inputs.forEach(function (input) {
      var wrapper = input.closest('[data-option-value-wrapper]');
      var isSoldOut = input.dataset.soldout === 'true';

      if (isSoldOut) {
        input.removeAttribute('disabled');
        input.disabled = false;

        if (wrapper) {
          wrapper.classList.add('option-value--soldout');
        }
      } else if (wrapper) {
        wrapper.classList.remove('option-value--soldout');
      }
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enableSoldOutOptions(document);
    });
  }

  function observeProductRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    enableSoldOutOptions(root);

    new MutationObserver(scheduleUpdate).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-soldout']
    });
  }

  function findProductRoots(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-product-form-area]')) observeProductRoot(root);
    root.querySelectorAll('[data-product-form-area]').forEach(observeProductRoot);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-product-form-area]')) scheduleUpdate();
  });

  findProductRoots(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) findProductRoots(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});
